import { Anchor } from "@mantine/core";

const MyHeader = () => {
  return (
    <Anchor href="/" size="1rem">
      Sākums
    </Anchor>
  );
};

export default MyHeader;
